import 'animate.css';
import React from 'react';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import Layout from './components/Layout';
import './index.css';
import RouteMiddleware from './middlewares/RouteMiddleware';
import routes from './routes/routes';

const App = () => {
    return (
        <React.Fragment>
            <Router>
                <Switch>
                    {routes.map((route, idx) => (
                        <RouteMiddleware path={route.path} layout={Layout} component={route.component} key={idx} isAuthProtected={false} />
                    ))}
                </Switch>
            </Router>
        </React.Fragment>
    );
};

export default App;
